const FindService = {

    "find_services": "Find Services",
    "service": "Service",

    "premise": "Premise",
    "service_category": "Category",
    "service_name": "Name",
    "mobile_number": "Mobile Number",
    "alternative_contact": "Alternative Contact Number",
    "email": "Email",
    "description": "Description",
    "address": "Address",
    "photo": "Photo",
    "status": "Status",
    "search": "Search",

    "category_registered_helper": "Registered Helper",
    "category_electrician": "Electrician",
    "category_plumber": "Plumber",
    "category_carpenter": "Carpenter",
    "category_technician": "Technician",
    "category_housekeeping": "Housekeeping Staff",
    "category_security": "Security Staff",
    "category_chairman": "Chairman",
    "category_admin": "Admin",
    "category_manager": "Manager",
    "category_emergency": "Emergency Contact",
    "category_other": "Other",

    "table_service_name": "NAME",
    "table_category": "CATEGORY",
    "table_mobile": "MOBILE",
    "table_status": "STATUS",

    "error_premise": "Select Premise",
    "error_service_category": "Select Category",
    "error_service_name": "Enter Name",
    "error_mobile_number": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number",
    "error_invalid_alt_contact": "Invalid Alternative Contact Number",
    "error_invalid_email": "Invalid Email",
    "error_status": "Select Status",

}

export default FindService;